import { render, staticRenderFns } from "./ColorDisplay.vue?vue&type=template&id=166096e7&scoped=true&"
import script from "./ColorDisplay.vue?vue&type=script&lang=ts&"
export * from "./ColorDisplay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166096e7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VEditDialog } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VEditDialog})
